import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const Container = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: 'gold',
  color: 'white',
  minHeight: '250px', // Increased height for longer text
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '20px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    padding: '10px', // Adjust padding for small screens
  },
}));

const Text = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem', // Slightly smaller font for better responsiveness
  fontWeight: 'bold',
  lineHeight: '1.5', // Adjust line height for readability
  transition: 'opacity 0.5s ease-in-out',
  width: '100%',
  maxWidth: '800px', // Limit text width for large screens
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem', // Smaller font size for small screens
  },
}));

const ArrowButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'white',
  zIndex: 10,
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
}));

function WhatPeopleSay() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    '"ACZ consistently delivers high-quality analytical results for all aspects of Mining and Environmental monitoring. I rely on their expertise for routine water monitoring, geochemical testing for mine waste characterization, and for implementing highly complex column and batch tests. Their knowledge, customer service, and attention to detail is second to none. I highly recommend ACZ for all your analytical needs."',
    '"I am very satisfied with their professionalism."',
    '"Their team is highly skilled and reliable."',
    '"Outstanding customer support and quality!"',
    '"Highly recommend their services to everyone."',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000); // Change text every 5 seconds
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  return (
    <Container>
      <ArrowButton onClick={handlePrev} sx={{ left: '10px' }}>
        <ArrowBackIosIcon />
      </ArrowButton>
      <Text key={currentIndex}>{testimonials[currentIndex]}</Text>
      <ArrowButton onClick={handleNext} sx={{ right: '10px' }}>
        <ArrowForwardIosIcon />
      </ArrowButton>
    </Container>
  );
}

export default WhatPeopleSay;